import './exclamation_mark.scss';
import exclamation_mark_icon from './exclamation_mark.svg';
import { vfIconSimpleExtender } from '../icon/icon.js';


/**
 * Exclamation Mark
 *
 * @data
 * Simple
 * {"attrs": {"class": "vf-icon-large"}}
 *
 * @data
 * Filled error
 * { "circle": "filled", "attrs": {"class": "vf-icon-large vf-error"}}
 *
 * @data
 * Filled warning
 * { "circle": "filled", "attrs": {"class": "vf-icon-large vf-warning"}}
 *
 * @data
 * Outline error
 * { "circle": "outline", "attrs": {"class": "vf-icon-large vf-error"}}
 *
 * @data
 * Outline warning
 * { "circle": "outline", "attrs": {"class": "vf-icon-large vf-warning"}}
 *
 * @styleguide components.icons.exclamation_mark
 */
export const vfExclamationMarkIcon = vfIconSimpleExtender('exclamation-mark', exclamation_mark_icon);
